import styled from 'styled-components';

export const Div = styled.div`
display: flex;
align-items: center;
justify-content: space-around;  
`;
